import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "bg-image-list"
};
var _hoisted_2 = ["onClick"];
var _hoisted_3 = ["src"];
var _hoisted_4 = ["src"];
var _hoisted_5 = {
  class: "footer-body"
};
import { MessagePlugin } from 'tdesign-vue-next';
import { ref, watch, onMounted } from 'vue';
import { useModel } from '@/hooks/useModel';
import BaseDialog from './BaseDialog.vue';
import { background, setBackground } from '@/api/personalHomepage';
export default {
  __name: 'ImageDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 默认
    defaultIndex: {
      type: String,
      default: ''
    },
    storeData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    type: {
      type: Number,
      default: 0 //0学生，1老师，不传默认0
    }
  },
  emits: ['update:visible', 'change'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var ellipse = require('@/assets/home/ellipse.svg');
    var ellipseL = require('@/assets/home/ellipse-L.svg');
    var emit = __emit;
    var visible = useModel({
      props: props,
      emit: emit,
      key: 'visible'
    });
    var banners = ref([]);
    var courent = ref('');
    watch(function () {
      return props.defaultIndex;
    }, function (val) {
      courent.value = val;
    }, {
      immediate: true
    });
    var handleImgClick = function handleImgClick(val) {
      courent.value = val;
    };
    var handleClose = function handleClose() {
      emit('update:visible', false);
    };
    var handleConfirm = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(val) {
        var id, backImageId, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              id = props.storeData.id;
              backImageId = val.find(function (item) {
                return item.backImageUrl === courent.value;
              }).id;
              _context.p = 1;
              _context.n = 2;
              return setBackground(id, backImageId);
            case 2:
              emit('change');
              handleClose();
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              MessagePlugin.error('请求失败，请重试');
            case 4:
              return _context.a(2);
          }
        }, _callee, null, [[1, 3]]);
      }));
      return function handleConfirm(_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    var getBanners = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var query, _yield$background, data, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              query = {
                type: props.type
              };
              _context2.n = 1;
              return background(query);
            case 1:
              _yield$background = _context2.v;
              data = _yield$background.data;
              banners.value = data.data;
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              MessagePlugin.error('请求失败，请重试');
            case 3:
              return _context2.a(2);
          }
        }, _callee2, null, [[0, 2]]);
      }));
      return function getBanners() {
        return _ref3.apply(this, arguments);
      };
    }();
    onMounted(function () {
      getBanners();
    });
    return function (_ctx, _cache) {
      var _component_t_button = _resolveComponent("t-button");
      return _openBlock(), _createBlock(BaseDialog, {
        visible: _unref(visible),
        "onUpdate:visible": _cache[1] || (_cache[1] = function ($event) {
          return _isRef(visible) ? visible.value = $event : null;
        }),
        title: "更换背景图"
      }, {
        body: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(banners.value, function (item, index) {
            return _openBlock(), _createElementBlock("div", {
              key: index,
              class: "img-item",
              onClick: function onClick($event) {
                return handleImgClick(item.backImageUrl);
              }
            }, [_createElementVNode("img", {
              src: item.backImageUrl,
              width: "100%",
              height: "100%",
              alt: ""
            }, null, 8, _hoisted_3), _createElementVNode("img", {
              class: "radio-icon",
              src: courent.value === item.backImageUrl ? _unref(ellipseL) : _unref(ellipse),
              alt: ""
            }, null, 8, _hoisted_4)], 8, _hoisted_2);
          }), 128))])];
        }),
        footer: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_5, [_createVNode(_component_t_button, {
            size: "small",
            theme: "default",
            onClick: handleClose
          }, {
            default: _withCtx(function () {
              return _toConsumableArray(_cache[2] || (_cache[2] = [_createTextVNode("取消", -1)]));
            }),
            _: 1
          }), _createVNode(_component_t_button, {
            size: "small",
            theme: "primary",
            onClick: _cache[0] || (_cache[0] = function ($event) {
              return handleConfirm(banners.value);
            })
          }, {
            default: _withCtx(function () {
              return _toConsumableArray(_cache[3] || (_cache[3] = [_createTextVNode("确定", -1)]));
            }),
            _: 1
          })])];
        }),
        _: 1
      }, 8, ["visible"]);
    };
  }
};